export {
  RemoteSelectionRings,
  type RemoteSelectionRingsProps,
  type SelectionDescriptor,
} from "@agent-native/toolkit/collab-ui";
